module.exports = __webpack_public_path__ + "img/anne.8f56d40f.jpeg";